import CardFeature from '~/components/Molecules/CardFeature/CardFeature.vue'

export default {
  props: {
    title: {
      type: String,
    },
    body: {
      type: String,
    },
    items: {
      type: Array,
    },
  },

  components: {
    hotCarousel: () => import('~/components/Molecules/Carousel/Carousel.vue'),
  },

  data() {
    return {
      cardFeature: CardFeature,

      swiperOptions: {
        slidesPerView: 1.1,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
        spaceBetween: 16,
        allowTouchMove: true,
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            slidesPerColumn: 2,
          },
          480: {
            slidesPerView: 2,
            slidesPerColumn: 2,
          },
          768: {
            slidesPerView: 2,
            slidesPerColumn: 3,
          },
          1024: {
            slidesPerView: 3,
            slidesPerColumn: 4,
            allowTouchMove: false,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      fractionPagination: true,
    }
  },
}
